import styles from "@/styles/footer.module.scss"
import Image from "next/image"
import Link from 'next/link'
import { useEffect, useState } from 'react'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

type BeianInfo = {
  icp: string
  mpsCode: string
  mpsText: string
}

const defaultBeianInfo: BeianInfo = {
  icp: '粤ICP备18049355号',
  mpsCode: '44010502003129',
  mpsText: '粤公网安备44010502003129',
}

const jiebeiliBeianInfo: BeianInfo = {
  icp: '粤ICP备18049355号',
  mpsCode: '44010502003088',
  mpsText: '粤公网安备44010502003088',
}

function resolveBeianInfoByHostname(hostname?: string): BeianInfo {
  if (hostname === 'www.jiebeili.cn') return jiebeiliBeianInfo
  return defaultBeianInfo
}

export default function Footer() {
  const [beianInfo, setBeianInfo] = useState<BeianInfo | null>(null)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setBeianInfo(resolveBeianInfoByHostname(window.location.hostname))
    }
  }, [])

  return (
    <div className={styles['comp-footer']}>
      <div className={styles['container']}>
        <Link
          href={'/'}
          legacyBehavior
        >
          <a 
            rel="noopener noreferrer"
          >
            <Image 
              className={styles['logo']}
              alt={'logo'}
              width={96}
              height={45}
              src={`${imageDomain}/logo.png`}
            ></Image>
          </a>
        </Link>

        <div className={styles['related-box']}>
          <div className={`${styles['related-item']} padding-right-40`}>
            <div className={styles['item-title']}>了解我们</div>

            <Link
              href="/about-us"
              legacyBehavior
            >
              <a className={styles['item-desc']} rel="noopener noreferrer">公司简介</a>
            </Link>

            <Link
              href="/company-news"
              legacyBehavior
            >
              <a className={styles['item-desc']} rel="noopener noreferrer">CS动态</a>
            </Link>

            <Link
              href="/careers"
              legacyBehavior
            >
              <a className={styles['item-desc']} rel="noopener noreferrer">加入我们</a>
            </Link>
          </div>

          <div
            className={`${styles['related-item']} padding-right-80`}
          >
            <div className={styles['item-title']}>联系我们</div>
            <div className={styles['item-desc']}>联系电话：</div>
            <div className={styles['item-desc']}>020-34331422</div>
          </div>

          <div className={styles['related-item']}>
            <Image 
              className={styles['qr-code']}
              alt={'qr-code'}
              width={107}
              height={107}
              src={`${imageDomain}/qr-code.png`}
            ></Image>
            <div 
              className={styles['item-desc']}
              style={{ textAlign: 'center' }}
            >扫一扫·关注我们</div>
          </div>
        </div>

      </div>

      <div className={styles['copy-right']}>
        Copyright &copy; 2003 - 2026 Jiebeili. All rights reserved. 杰钡利科技 版权所有
        <Link
          href="https://beian.miit.gov.cn/#/Integrated/index"
          legacyBehavior
        >
          <a rel="noopener noreferrer"> {defaultBeianInfo.icp}</a>
        </Link>
      </div>

      <div className={styles['copy-right']} style={{ paddingTop: '12px' }}>
        <Link
          href={`https://beian.mps.gov.cn/#/query/webSearch?code=${defaultBeianInfo.mpsCode}`}
          legacyBehavior
        >
          <a style={{ display: 'inline-flex', alignItems: 'center' }} rel="noopener noreferrer" target="_blank">
            <Image
              style={{ marginRight: 5 }}
              alt={'record-keeping'}
              width={18}
              height={20}
              src={`${imageDomain}/record-keeping.png`}
            ></Image>
            {defaultBeianInfo.mpsText}
          </a>
        </Link>
        <Link
          href={`https://beian.mps.gov.cn/#/query/webSearch?code=${jiebeiliBeianInfo.mpsCode}`}
          legacyBehavior
        >
          <a style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 10 }} rel="noopener noreferrer" target="_blank">
            <Image
              style={{ marginRight: 5 }}
              alt={'record-keeping'}
              width={18}
              height={20}
              src={`${imageDomain}/record-keeping.png`}
            ></Image>
            {jiebeiliBeianInfo.mpsText}
          </a>
        </Link>
      </div>
    </div>
  )
}